var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongratsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 103,
    viewBox: "0 0 104 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9987 0.63916C80.2305 0.63916 103.15 23.5594 103.15 51.7907C103.15 80.022 80.2305 102.942 51.9987 102.942C23.7669 102.942 0.847168 80.022 0.847168 51.7907C0.847168 23.5594 23.7669 0.63916 51.9987 0.63916Z",
    fill: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0002 33.8875C61.8814 33.8875 69.9032 41.9095 69.9032 51.7905C69.9032 61.6714 61.8814 69.6935 52.0002 69.6935C42.119 69.6935 34.0972 61.6714 34.0972 51.7905C34.0972 41.9095 42.119 33.8875 52.0002 33.8875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0002 33.8875C61.8814 33.8875 69.9032 41.9095 69.9032 51.7905C69.9032 61.6714 61.8814 69.6935 52.0002 69.6935C42.119 69.6935 34.0972 61.6714 34.0972 51.7905C34.0972 41.9095 42.119 33.8875 52.0002 33.8875Z",
    stroke: "white",
    strokeWidth: 2.55758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M75.3951 31.9371C79.9424 37.2906 82.688 44.2226 82.688 51.7908C82.688 68.7296 68.9359 82.4817 51.9971 82.4817C35.0582 82.4817 21.3062 68.7296 21.3062 51.7908C21.3062 34.8519 35.0582 21.0999 51.9971 21.0999",
    stroke: "#653494",
    strokeWidth: 2.55758,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.9048 47.3509L51.9982 55.4431L69.9013 37.54",
    stroke: "#653494",
    strokeWidth: 1.27879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratsActive);
export default __webpack_public_path__ + "static/media/congrats-active.f98ce0791e531f013bac5ddb561b9eda.svg";
export { ForwardRef as ReactComponent };